// The counseling index, read by everyone. The admin writes it from Claude Desktop.
import type { CounselingTopicWithPassages } from "@bibleunleashed/shared";
import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export function useCounselingTopics() {
  return useQuery({
    queryKey: ["counseling"],
    queryFn: () => api<CounselingTopicWithPassages[]>("/api/counseling"),
    staleTime: 5 * 60_000,
  });
}
